import React from 'react';

import Spinner from '../../loaders/Spinner';

import './SearchResultsLoading.scss';

const SearchResultsLoading = (props) => (
    <div className="SearchResultsLoading">
        <Spinner show />
    </div>
);

export default SearchResultsLoading;
